// extracted by mini-css-extract-plugin
export default {"preferredDate":"preferredDate__ODZkZ","yearLabel":"yearLabel__OTJkZ","listItem":"listItem__NTBlY","bullet":"bullet__MDI0N"};